<template>
  <div class="side-nav-container w-100">
    <div class="side-nav bg-white w-100">
      <ClientOnly>
        <div class="side-nav-inner p-0 p-xl-3">
          <div class="sideBar-header side-nav-title" :class="width < breakpoints.screen_laptop && 'shadow-sm'">
            <div class="d-flex align-items-center justify-content-between w-100 mb-1">
              <div class="d-flex align-items-center gap-2">
                <i class="material-symbols-rounded fsz-20 d-block d-xl-none"
                  @click="emit('update:showFilterSideBar', false)">arrow_back</i>
                <h4>
                  Filtres <span>({{ searchStore.getSelectedFilterCounte }})</span>
                </h4>
              </div>
              <div>
                <div v-if="width < breakpoints.screen_laptop"
                  class="text-primary clear-container d-flex align-items-center" @click="clearFilter(searchValues)">
                  <i class="material-symbols-rounded fsz-20 fw-medium">delete</i>
                  <label class="btn fsz-14 p-0 btn-border-hidden text-primary">Effacer les filtres</label>
                </div>

                <button v-else @click="clearFilter(searchValues)" class="clear"
                  :class="searchStore.getSelectedFilterCounte ? 'bg-danger-600 text-white border-danger-700' : ''">
                  EFFACER
                </button>
              </div>
            </div>
          </div>
          <div v-if="width < breakpoints.screen_laptop && searchStore.getFilterCounte" class="px-3 mt-3">
            <h4 class="fsz-16">Filtres sélectionnés: </h4>
            <div v-if="searchValues" class="d-flex flex-row pt-1 overflow-scroll">
              <div v-for="(value, key) in searchValues" :key="key">
                <div v-if="Array.isArray(value)" class="d-flex">
                  <!-- makes / models -->
                  <span v-if="key === 'makes' || key === 'models'" v-for="(val, index) in value"
                    :key="`${key}-${index}`"
                    class="badge badge-solid-gray-200 text-gray-600 d-flex align-items-center me-1 chip">
                    {{ val?.name }}
                    <i class="material-symbols-rounded fsz-16 ms-1" @click="clearSpecficFilter(key, index)">close</i>
                  </span>

                  <!-- placesNbr -->
                  <span v-else-if="key === 'placesNbr'" v-for="(val, index) in value" :key="`placesNbr-${index}`"
                    class="badge badge-solid-gray-200 text-gray-600 d-flex align-items-center me-1 chip">
                    {{ 'Nombre de places: ' + val }}
                    <i class="material-symbols-rounded fsz-16" @click="clearSpecficFilter(key, index)">
                      close
                    </i>
                  </span>

                  <!-- Other array filters -->
                  <span v-else-if="!key.includes('makesIds') && !key.includes('modelsIds')"
                    v-for="(val, index) in value" :key="`other-${key}-${index}`"
                    class="badge badge-solid-gray-200 text-gray-600 d-flex align-items-center me-1 chip">
                    {{ val }}
                    <i class="material-symbols-rounded fsz-16" @click="clearSpecficFilter(key, index)">
                      close
                    </i>
                  </span>
                </div>

                <!-- Boolean or single value like 'others' -->
                <div v-else-if="key === 'others' && value" class="d-flex">
                  <span class="badge badge-solid-gray-200 text-gray-600 d-flex align-items-center me-1 chip">
                    Autre
                    <i class="material-symbols-rounded fsz-16" @click="clearSpecficFilter(key)">
                      close
                    </i>
                  </span>
                </div>

                <!-- Scalar values (min/max price, km, year...) -->
                <div v-else-if="value && key !== 'front'" class="d-flex">
                  <span class="badge badge-solid-gray-200 text-gray-600 d-flex align-items-center me-1 chip">
                    <span v-if="key === 'minPrice'">de {{ usePriceFormat(value) }} DT</span>
                    <span v-else-if="key === 'maxPrice'">à {{ usePriceFormat(value) }} DT</span>
                    <span v-else-if="key === 'fromRegYear'">de l'année {{ value }}</span>
                    <span v-else-if="key === 'toRegYear'">à l'année {{ value }}</span>
                    <span v-else-if="key === 'minKilometers'">de {{ usePriceFormat(value) }} km</span>
                    <span v-else-if="key === 'maxKilometers'">à {{ usePriceFormat(value) }} km</span>
                    <i class="material-symbols-rounded fsz-16" @click="clearSpecficFilter(key)">
                      close
                    </i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="my-3 my-xl-0 sideBar-body pb-64 pb-xl-11 px-3 px-xl-0">
            <div>
              <div class="d-flex justify-content-between align-items-center" :class="{ 'mb-3': isMobileFilterSheet }">
                <span class="me-auto fsz-14 fw-normal d-flex align-items-center gap-1 text-gray-500">
                  <i class="material-symbols-rounded fsz-16">location_on</i>

                  <span v-if="city">
                    <span>{{ city }}</span>
                  </span>
                  <span v-else>Toute la Tunisie</span>
                </span>
                <label v-if="!isMobileFilterSheet" for="adress"
                  class="btn fsz-14 fw-normal p-0 btn-border-hidden text-primary">
                  Sélectionner
                </label>
                <button v-else type="button" class="btn fsz-14 fw-normal p-0 btn-border-hidden text-primary"
                  @click="openMobileSheet('city')">
                  Sélectionner
                </button>
              </div>
              <div v-if="!isMobileFilterSheet" class="multi-select-hidden">
                <MultiSelect :ref="(el) => (element['citys'] = el)" inputId="adress" class="w-100"
                  v-model="searchStore.selectedInput.cities" :options="cities" panelClass="filterbar-city-panel"
                  optionLabel="name" optionValue="name" :panelStyle="{ zIndex: 1032 }" :filter="true"
                  filterPlaceholder="Rechercher une adresse..." :placeholder="'Tout les villes'"
                  @show="forceCityPanelZIndex">
                  <template #footer>
                    <div class="p-3 d-flex gap-2 justify-content-between border-top">
                      <button @click="
                        (searchValues.cities = []),
                        searchStore.selectedInput.cities = searchValues.cities,
                        searchStore.searchCount(),
                        toggle($event, 'citys')
                        " class="btn btn-solid-gray-400 small-btn w-100">
                        Effacer
                      </button>
                      <button @click="
                        searchStore.selectedInput.cities = searchValues.cities,
                        searchStore.searchCount(),
                        toggle($event, 'citys')"
                        class="btn btn-solid-primary-600 small-btn w-100 d-flex justify-content-center"
                        :disabled="searchStore.getPendingStats.fetchResult">
                        <div v-if="searchStore.getPendingStats.fetchResult" class="spinner-border text-white"
                          role="status"></div>
                        Appliquer
                      </button>
                    </div>
                  </template>
                </MultiSelect>
              </div>
            </div>

            <div class="mb-12 multi-select">
              <span class="label">Marques</span>
              <MultiSelect v-if="!isMobileFilterSheet" appendTo="self" inputId="filter-makes-multiselect"
                :ref="(el) => (element['mark'] = el)" class="w-100" v-model="searchValues.makes"
                :options="searchStore.getMakes" optionLabel="name" :showToggleAll="false" :filter="true"
                filterPlaceholder="Rechercher une marque..." :placeholder="'Toutes les marques'">
                <template #footer>
                  <div class="p-3 d-flex gap-2 justify-content-between border-top">
                    <button @click="
                      (searchValues.makes = []),
                      (searchValues.models = []),
                      searchStore.selectedInput.makes = searchValues.makes,
                      searchStore.searchCount(),
                      toggle($event, 'mark')
                      " class="btn btn-solid-gray-400 small-btn w-100">
                      Effacer
                    </button>
                    <button @click="
                      searchStore.selectedInput.makes = searchValues.makes,
                      getUserMakesId(),
                      searchStore.searchCount(),
                      toggle($event, 'mark')
                      " class="btn btn-solid-primary-600 small-btn w-100 d-flex justify-content-center"
                      :disabled="searchStore.getPendingStats.fetchResult">
                      <div v-if="searchStore.getPendingStats.fetchResult" class="spinner-border text-white"
                        role="status"></div>
                      Appliquer
                    </button>
                  </div>
                </template>
              </MultiSelect>
              <button v-else type="button" class="mobile-select-trigger mobile-select-trigger--inside-label"
                @click="openMobileSheet('makes')">
                <span :class="makesSummary ? 'mobile-select-trigger__value' : 'mobile-select-trigger__placeholder'">
                  {{ makesSummary || 'Toutes les marques' }}
                </span>
                <i class="material-icons-outlined text-gray-500 fsz-18">keyboard_arrow_down</i>
              </button>
            </div>

            <div class="mb-12 multi-select">
              <span class="label">Modèles</span>
              <MultiSelect v-if="!isMobileFilterSheet" appendTo="self" inputId="filter-models-multiselect"
                :ref="(el) => (element['model'] = el)" class="w-100" v-model="searchValues.models"
                :options="searchStore.getModels" optionLabel="name"
                :optionGroupLabel="searchStore.getModels && searchStore.getModels[0]?.make ? 'make' : ''"
                :optionGroupChildren="searchStore.getModels && searchStore.getModels[0]?.make ? 'models' : ''"
                :filter="true"
                :disabled="searchStore.getModels && searchStore.getModels.length === 0 || (searchValues.makes && !searchValues.makes.length)"
                :showToggleAll="false" filterPlaceholder="Rechercher un modèle…" :placeholder="'Tous les modèles'">
                <template #footer>
                  <div class="p-3 d-flex gap-2 justify-content-between border-top">
                    <button @click="
                      (searchValues.models = []),
                      searchStore.selectedInput.models = searchValues.models,
                      searchStore.searchCount(),
                      toggle($event, 'model')
                      " class="btn btn-solid-gray-400 small-btn w-100">
                      Effacer
                    </button>
                    <button @click="
                      searchStore.selectedInput.models = searchValues.models,
                      searchStore.searchCount(),
                      toggle($event, 'model')
                      " class="btn btn-solid-primary-600 small-btn w-100 d-flex justify-content-center"
                      :disabled="searchStore.getPendingStats.fetchResult">
                      <div v-if="searchStore.getPendingStats.fetchResult" class="spinner-border text-white"
                        role="status"></div>
                      Appliquer
                    </button>
                  </div>
                </template>
              </MultiSelect>
              <button v-else type="button" class="mobile-select-trigger mobile-select-trigger--inside-label"
                :disabled="searchStore.getModels && searchStore.getModels.length === 0 || (searchValues.makes && !searchValues.makes.length)"
                @click="openMobileSheet('models')">
                <span :class="modelsSummary ? 'mobile-select-trigger__value' : 'mobile-select-trigger__placeholder'">
                  {{ modelsSummary || 'Tous les modèles' }}
                </span>
                <i class="material-icons-outlined text-gray-500 fsz-18">keyboard_arrow_down</i>
              </button>
            </div>

            <div class="mb-12 multi-select">
              <span class="label">Finitions</span>
              <MultiSelect v-if="!isMobileFilterSheet" appendTo="self" inputId="filter-finition-multiselect"
                class="w-100" :ref="(el) => (element['finition'] = el)" optionLabel="name" :filter="true"
                :disabled="true" :showToggleAll="false" filterPlaceholder="Rechercher une finition..."
                :placeholder="'Toutes les finitions'">
                <template #footer>
                  <div class="p-3 d-flex gap-2 justify-content-between border-top">
                    <button class="btn btn-solid-gray-400 small-btn w-100">Effacer</button>
                    <button @click="toggle($event, 'finition')" :disabled="searchStore.getPendingStats.fetchResult"
                      class="btn btn-solid-primary-600 small-btn w-100 d-flex justify-content-center">
                      <div v-if="searchStore.getPendingStats.fetchResult" class="spinner-border text-white"
                        role="status"></div>
                      Appliquer
                    </button>
                  </div>
                </template>
              </MultiSelect>
              <button v-else type="button" class="mobile-select-trigger mobile-select-trigger--inside-label" disabled>
                <span class="mobile-select-trigger__placeholder">Toutes les finitions</span>
                <i class="material-icons-outlined text-gray-500 fsz-18">keyboard_arrow_down</i>
              </button>
            </div>
            <div class="border-top"></div>
            <Panel class="filter-panels" header="Type de carrosserie" toggleable>

              <div v-for="categories of carsType" :key="categories.name" class="field-checkbox">
                <Checkbox :name="categories.key" :value="categories.key" :inputId="categories.key"
                  v-model="searchValues.categories" @change="
                    searchStore.selectedInput.categories = searchValues.categories,
                    searchStore.searchCount()
                    " />
                <label :for="categories.key">{{ categories.name }}</label>
              </div>
              <div key="others" class="field-checkbox">
                <Checkbox name="others" :binary="true" inputId="others" v-model="searchValues.others" @change="
                  searchStore.selectedInput.others = searchValues.others,
                  searchStore.searchCount()" />
                <label for="others">Autre</label>
              </div>
            </Panel>
            <div class="border-bottom pt-3"></div>
            <Panel class="filter-panels" header="Prix" toggleable>
              <div v-if="!isMobileFilterSheet" class="d-flex double-select mb-12">
                <Dropdown inputId="filter-min-price-dropdown" appendTo="self" showClear v-model="searchValues.minPrice"
                  class="col-6 first-select" @change="priceMaxUpdate(searchValues.minPrice, false)" optionLabel="label"
                  optionValue="value" :options="priceStart" placeholder="De" :pt="{
                    panel: { class: 'filterBar-dropdown' },
                  }" />
                <Dropdown inputId="filter-max-price-dropdown" appendTo="self" showClear v-model="searchValues.maxPrice"
                  class="col-6 second-select" optionLabel="label" optionValue="value" :options="priceEnd"
                  placeholder="À" @change="priceMaxUpdate(searchValues.maxPrice, true)" :pt="{
                    panel: { class: 'filterBar-dropdown' },
                  }" />
              </div>
              <div v-else class="mobile-select-trigger-pair mb-12">
                <button type="button"
                  class="mobile-select-trigger mobile-select-trigger--split mobile-select-trigger--split-start"
                  @click="openMobileSheet('minPrice')">
                  <span
                    :class="searchValues.minPrice == null ? 'mobile-select-trigger__placeholder' : 'mobile-select-trigger__value'">
                    {{ getOptionSummary(searchValues.minPrice, priceStart, "De") }}
                  </span>
                  <i class="material-icons-outlined fsz-18 mobile-select-trigger__icon">keyboard_arrow_down</i>
                </button>
                <button type="button"
                  class="mobile-select-trigger mobile-select-trigger--split mobile-select-trigger--split-end"
                  @click="openMobileSheet('maxPrice')">
                  <span
                    :class="searchValues.maxPrice == null ? 'mobile-select-trigger__placeholder' : 'mobile-select-trigger__value'">
                    {{ getOptionSummary(searchValues.maxPrice, priceEnd, "À") }}
                  </span>
                  <i class="material-icons-outlined fsz-18 mobile-select-trigger__icon">keyboard_arrow_down</i>
                </button>
              </div>
            </Panel>
            <div class="border-bottom pt-3"></div>

            <Panel class="filter-panels" header="Kilométrage" toggleable>
              <div v-if="!isMobileFilterSheet" class="d-flex double-select mb-12">
                <Dropdown inputId="filter-min-km-dropdown" appendTo="self" showClear
                  v-model="searchValues.minKilometers" class="col-6 first-select" optionLabel="label"
                  optionValue="value" @change="distanceMaxUpdate(searchValues.minKilometers, false)"
                  :options="distanceStart" placeholder="De" :pt="{
                    panel: { class: 'filterBar-dropdown' },
                  }" />
                <Dropdown inputId="filter-max-km-dropdown" appendTo="self" showClear
                  v-model="searchValues.maxKilometers" class="col-6 second-select" :options="distanceEnd"
                  optionLabel="label" optionValue="value" placeholder="À"
                  @change="distanceMaxUpdate(searchValues.maxKilometers, true)" :pt="{
                    panel: { class: 'filterBar-dropdown' },
                  }" />
              </div>
              <div v-else class="mobile-select-trigger-pair mb-12">
                <button type="button"
                  class="mobile-select-trigger mobile-select-trigger--split mobile-select-trigger--split-start"
                  @click="openMobileSheet('minKilometers')">
                  <span
                    :class="searchValues.minKilometers == null ? 'mobile-select-trigger__placeholder' : 'mobile-select-trigger__value'">
                    {{ getOptionSummary(searchValues.minKilometers, distanceStart, "De") }}
                  </span>
                  <i class="material-icons-outlined fsz-18 mobile-select-trigger__icon">keyboard_arrow_down</i>
                </button>
                <button type="button"
                  class="mobile-select-trigger mobile-select-trigger--split mobile-select-trigger--split-end"
                  @click="openMobileSheet('maxKilometers')">
                  <span
                    :class="searchValues.maxKilometers == null ? 'mobile-select-trigger__placeholder' : 'mobile-select-trigger__value'">
                    {{ getOptionSummary(searchValues.maxKilometers, distanceEnd, "À") }}
                  </span>
                  <i class="material-icons-outlined fsz-18 mobile-select-trigger__icon">keyboard_arrow_down</i>
                </button>
              </div>
            </Panel>
            <div class="border-bottom pt-3"></div>

            <Panel class="filter-panels" header="Année" toggleable>
              <div v-if="!isMobileFilterSheet" class="d-flex double-select mb-12">
                <Dropdown inputId="filter-from-year-dropdown" appendTo="self" showClear
                  v-model="searchValues.fromRegYear" class="col-6 first-select"
                  @change="yearListUpdate(searchValues.fromRegYear, false)" :options="yearStart" placeholder="De" :pt="{
                    panel: { class: 'filterBar-dropdown' },
                  }" />
                <Dropdown inputId="filter-to-year-dropdown" appendTo="self" showClear v-model="searchValues.toRegYear"
                  class="col-6 second-select" :options="yearEnd" placeholder="À"
                  @change="yearListUpdate(searchValues.toRegYear, true)" :pt="{
                    panel: { class: 'filterBar-dropdown' },
                  }" />
              </div>
              <div v-else class="mobile-select-trigger-pair mb-12">
                <button type="button"
                  class="mobile-select-trigger mobile-select-trigger--split mobile-select-trigger--split-start"
                  @click="openMobileSheet('fromRegYear')">
                  <span
                    :class="searchValues.fromRegYear == null ? 'mobile-select-trigger__placeholder' : 'mobile-select-trigger__value'">
                    {{ getOptionSummary(searchValues.fromRegYear, yearStart, "De") }}
                  </span>
                  <i class="material-icons-outlined fsz-18 mobile-select-trigger__icon">keyboard_arrow_down</i>
                </button>
                <button type="button"
                  class="mobile-select-trigger mobile-select-trigger--split mobile-select-trigger--split-end"
                  @click="openMobileSheet('toRegYear')">
                  <span
                    :class="searchValues.toRegYear == null ? 'mobile-select-trigger__placeholder' : 'mobile-select-trigger__value'">
                    {{ getOptionSummary(searchValues.toRegYear, yearEnd, "À") }}
                  </span>
                  <i class="material-icons-outlined fsz-18 mobile-select-trigger__icon">keyboard_arrow_down</i>
                </button>
              </div>
            </Panel>
            <div class="border-bottom pt-3"></div>

            <Panel class="filter-panels" header="Carburant" toggleable>
              <div v-for="fuel of fuelType" :key="fuel.name" class="field-checkbox">
                <Checkbox :name="fuel.name" :value="fuel.name" :inputId="fuel.name" v-model="searchValues.fuelTypes"
                  @change="
                    searchStore.selectedInput.fuelTypes = searchValues.fuelTypes,
                    searchStore.searchCount()
                    " />
                <label :for="fuel.name">{{ fuel.name }}</label>
              </div>
            </Panel>
            <div class="border-bottom pt-3"></div>

            <Panel class="filter-panels" header="Boite" toggleable>
              <div v-for="trim of transmissions" :key="trim.name" class="field-checkbox">
                <Checkbox :name="trim.name" :value="trim.name" :inputId="trim.name" v-model="searchValues.transmissions"
                  @change="
                    searchStore.selectedInput.transmissions = searchValues.transmissions,
                    searchStore.searchCount()
                    " />
                <label :for="trim.name">{{ trim.name }}</label>
              </div>
            </Panel>
            <div class="border-bottom pt-3"></div>

            <Panel class="filter-panels" header="Nombre de places" toggleable>
              <div v-for="index in 6" :key="index">
                <div v-if="index != 1" class="field-checkbox">
                  <Checkbox :name="'place' + index" :inputId="String(index)" :value="index"
                    v-model="searchValues.placesNbr" @change="
                      searchStore.selectedInput.placesNbr = searchValues.placesNbr,
                      searchStore.searchCount()
                      " />
                  <label class="form-check-label" :for="String(index)">{{
                    index
                  }}</label>
                </div>
              </div>
            </Panel>
            <div class="border-bottom pt-3"></div>

            <Panel class="filter-panels" header="Couleur extérieure" toggleable>
              <div class="p-2">
                <FormRadioColorPicker :grid-class="'row row-cols-2 g-4'" :colorList="colors" :multipe="true"
                  v-model:colors="searchValues.bodyColor" @update:colors="
                    searchStore.selectedInput.bodyColor = searchValues.bodyColor,
                    searchStore.searchCount()
                    " />
              </div>
            </Panel>
          </div>
        </div>
      </ClientOnly>
      <div class="sideBar-footer d-xl-none">
        <button v-show="width < breakpoints.screen_laptop" class="btn btn-solid-primary-600 fsz-14 w-100 mt-2"
          @click="handleMobileApplySearch">
          <div v-if="searchStore.getPendingStats.fetchResult" class="spinner-border text-white" role="status">

          </div>

          <span v-else>
            {{ searchStore.getAnnounceCount ?? searchStore.getFetchResult?.totalCount ?? 0 }} Résultats
          </span>
        </button>
      </div>
    </div>
  </div>
  <MobileOptionsSheet v-if="isMobileFilterSheet" :visible="mobileSheetOpen.city"
    :model-value="searchValues.cities || []" :options="cities" optionLabel="name" optionValue="name"
    searchPlaceholder="Rechercher une adresse..." :pending="searchStore.getPendingStats.fetchResult"
    @update:visible="(value) => setMobileSheetVisible('city', value)" @update:modelValue="applyMobileCities" />

  <MobileOptionsSheet v-if="isMobileFilterSheet" :visible="mobileSheetOpen.makes"
    :model-value="searchValues.makes || []" :options="searchStore.getMakes" optionLabel="name"
    searchPlaceholder="Rechercher une marque..." :pending="searchStore.getPendingStats.fetchResult"
    @update:visible="(value) => setMobileSheetVisible('makes', value)" @update:modelValue="applyMobileMakes" />

  <MobileOptionsSheet v-if="isMobileFilterSheet" :visible="mobileSheetOpen.models"
    :model-value="searchValues.models || []" :options="searchStore.getModels" optionLabel="name"
    :optionGroupLabel="searchStore.getModels && searchStore.getModels[0]?.make ? 'make' : ''"
    :optionGroupChildren="searchStore.getModels && searchStore.getModels[0]?.make ? 'models' : ''"
    searchPlaceholder="Rechercher un modèle..." :pending="searchStore.getPendingStats.fetchResult"
    @update:visible="(value) => setMobileSheetVisible('models', value)" @update:modelValue="applyMobileModels" />

  <MobileOptionsSheet v-if="isMobileFilterSheet" :visible="mobileSheetOpen.minPrice"
    :model-value="searchValues.minPrice" :options="priceStart" optionLabel="label" optionValue="value" :multiple="false"
    :searchable="false" searchPlaceholder="Rechercher un prix..." :pending="searchStore.getPendingStats.fetchResult"
    @update:visible="(value) => setMobileSheetVisible('minPrice', value)" @update:modelValue="applyMobileMinPrice" />

  <MobileOptionsSheet v-if="isMobileFilterSheet" :visible="mobileSheetOpen.maxPrice"
    :model-value="searchValues.maxPrice" :options="priceEnd" optionLabel="label" optionValue="value" :multiple="false"
    :searchable="false" searchPlaceholder="Rechercher un prix..." :pending="searchStore.getPendingStats.fetchResult"
    @update:visible="(value) => setMobileSheetVisible('maxPrice', value)" @update:modelValue="applyMobileMaxPrice" />

  <MobileOptionsSheet v-if="isMobileFilterSheet" :visible="mobileSheetOpen.minKilometers"
    :model-value="searchValues.minKilometers" :options="distanceStart" optionLabel="label" optionValue="value"
    :multiple="false" :searchable="false" searchPlaceholder="Rechercher un kilométrage..."
    :pending="searchStore.getPendingStats.fetchResult"
    @update:visible="(value) => setMobileSheetVisible('minKilometers', value)"
    @update:modelValue="applyMobileMinKilometers" />

  <MobileOptionsSheet v-if="isMobileFilterSheet" :visible="mobileSheetOpen.maxKilometers"
    :model-value="searchValues.maxKilometers" :options="distanceEnd" optionLabel="label" optionValue="value"
    :multiple="false" :searchable="false" searchPlaceholder="Rechercher un kilométrage..."
    :pending="searchStore.getPendingStats.fetchResult"
    @update:visible="(value) => setMobileSheetVisible('maxKilometers', value)"
    @update:modelValue="applyMobileMaxKilometers" />

  <MobileOptionsSheet v-if="isMobileFilterSheet" :visible="mobileSheetOpen.fromRegYear"
    :model-value="searchValues.fromRegYear" :options="yearStart" :multiple="false" :searchable="false"
    searchPlaceholder="Rechercher une année..." :pending="searchStore.getPendingStats.fetchResult"
    @update:visible="(value) => setMobileSheetVisible('fromRegYear', value)" @update:modelValue="applyMobileFromYear" />

  <MobileOptionsSheet v-if="isMobileFilterSheet" :visible="mobileSheetOpen.toRegYear"
    :model-value="searchValues.toRegYear" :options="yearEnd" :multiple="false" :searchable="false"
    searchPlaceholder="Rechercher une année..." :pending="searchStore.getPendingStats.fetchResult"
    @update:visible="(value) => setMobileSheetVisible('toRegYear', value)" @update:modelValue="applyMobileToYear" />

  <div class="d-none d-xl-block bottom-0 bg-white p-3 btn-result">
    <button class="btn btn-solid-primary-600 fsz-14 w-100 p-3" @click="applySearch">
      <div v-if="searchStore.getPendingStats.fetchResult" class="spinner-border text-white" role="status"></div>
      <span v-else>
        {{ searchStore.getAnnounceCount ?? searchStore.getFetchResult?.totalCount ?? 0 }} Résultats
      </span>
    </button>
  </div>
</template>

<script setup lang="ts">
import cities from "~/utils/tunisia_state.js";
import { prix, distance } from "~/utils/filter_varaibles.js";
import { carsType, fuelType, transmissions } from "~/utils/cars_options";
import { initializeInputs, searchQuerys } from "~/utils/searchFilters"
import { useMobileSheetState } from "~/composables/useMobileSheetState";

const { width } = useWindowSize();
const isMobileFilterSheet = computed(() => width.value < breakpoints.screen_laptop);
const dashStore = useDashboardStore();
const searchStore = useSearchStore();
const uiStore = useUiStateStore();
const { query } = useRoute();
const router = useRouter();

const props = defineProps({
  showFilterSideBar: { type: Boolean, default: false }
});

// 
const emit = defineEmits<{
  (e: 'update:showFilterSideBar', val: boolean): void,
  (e: 'scrollToTop', val: boolean): any,
  (e: 'totalCount', val: number): any,
  (e: 'apply-search'): void,
}>()



let searchValues: UserSearchInput = reactive({} as UserSearchInput);
const mobileSheetKeys = [
  "city",
  "makes",
  "models",
  "minPrice",
  "maxPrice",
  "minKilometers",
  "maxKilometers",
  "fromRegYear",
  "toRegYear",
] as const;
type MobileSheetKey = (typeof mobileSheetKeys)[number];
const {
  mobileSheetOpen,
  openMobileSheet,
  setMobileSheetVisible,
} = useMobileSheetState<MobileSheetKey>(mobileSheetKeys, {
  isEnabled: isMobileFilterSheet,
});

const formatArraySummary = (
  list: any[] | undefined,
  labelKey: string
): string => {
  if (!Array.isArray(list) || list.length === 0) return "";
  const extractLabel = (entry: any) => {
    if (entry == null) return "";
    if (typeof entry === "object") return String(entry?.[labelKey] ?? "");
    return String(entry);
  };

  if (list.length === 1) return extractLabel(list[0]);
  return `${extractLabel(list[0])}, +(${list.length - 1})`;
};

const makesSummary = computed(() =>
  formatArraySummary(searchValues.makes as any[], "name")
);

const modelsSummary = computed(() =>
  formatArraySummary(searchValues.models as any[], "name")
);

const getOptionSummary = (
  value: number | null | undefined,
  options: any[],
  placeholder: string
): string => {
  if (value == null || value === undefined) return placeholder;
  const matched = Array.isArray(options)
    ? options.find((entry: any) =>
      typeof entry === "object" ? entry?.value === value : entry === value
    )
    : undefined;
  if (!matched) return String(value);
  if (typeof matched === "object") return String(matched?.label ?? matched?.value ?? value);
  return String(matched);
};

const applyMobileCities = async (nextValue: any[] | any | null) => {
  const selection = Array.isArray(nextValue) ? nextValue : [];
  searchValues.cities = [...selection];
  searchStore.selectedInput.cities = [...selection];
  await searchStore.searchCount();
};

const applyMobileMakes = async (nextValue: any[] | any | null) => {
  const selection = Array.isArray(nextValue) ? nextValue : [];
  searchValues.makes = [...selection];
  searchStore.selectedInput.makes = [...selection];
  await searchStore.searchCount();
  getUserMakesId();
};

const applyMobileModels = async (nextValue: any[] | any | null) => {
  const selection = Array.isArray(nextValue) ? nextValue : [];
  searchValues.models = [...selection];
  searchStore.selectedInput.models = [...selection];
  await searchStore.searchCount();
};

const applyMobileMinPrice = async (nextValue: number | null) => {
  searchValues.minPrice = nextValue;
  priceMaxUpdate(nextValue, false);
};

const applyMobileMaxPrice = async (nextValue: number | null) => {
  searchValues.maxPrice = nextValue;
  priceMaxUpdate(nextValue, true);
};

const applyMobileMinKilometers = async (nextValue: number | null) => {
  searchValues.minKilometers = nextValue;
  distanceMaxUpdate(nextValue, false);
};

const applyMobileMaxKilometers = async (nextValue: number | null) => {
  searchValues.maxKilometers = nextValue;
  distanceMaxUpdate(nextValue, true);
};

const applyMobileFromYear = async (nextValue: number | null) => {
  searchValues.fromRegYear = nextValue;
  yearListUpdate(nextValue, false);
};

const applyMobileToYear = async (nextValue: number | null) => {
  searchValues.toRegYear = nextValue;
  yearListUpdate(nextValue, true);
};

const createEmptySearchValues = (): UserSearchInput => ({
  cities: [],
  makes: [],
  models: [],
  categories: [],
  fuelTypes: [],
  transmissions: [],
  minPrice: null,
  maxPrice: null,
  minKilometers: null,
  maxKilometers: null,
  fromRegYear: null,
  toRegYear: null,
  placesNbr: [],
  others: false,
  bodyColor: [],
  otherColors: false,
  front: undefined
});

const syncSearchValues = (input: Partial<UserSearchInput> = {}) => {
  const defaults = createEmptySearchValues();
  Object.assign(searchValues, defaults, input);
  if (!searchValues.bodyColor) searchValues.bodyColor = [];
  if (typeof searchValues.bodyColor === 'string') {
    searchValues.bodyColor = [searchValues.bodyColor];
  }
};

// close dropdown on search apply
const element: any = reactive({})
const toggle = (event: any, key: string) => {
  element[key].hide(event);
};

const forceCityPanelZIndex = async () => {
  await nextTick();
  const panel = document.querySelector('.filterbar-city-panel');
  if (panel instanceof HTMLElement) {
    panel.style.setProperty('z-index', '1032', 'important');
  }
};

// util fucntion
const findIndexByValue = (value: number, data: any) => {
  let index = -1;
  for (let i = 0; i < data.length; i++) {
    if (data[i].value === value) {
      index = i;
      break;
    }
  }

  return index;
};
const colors = ref([
  {
    value: "Noir",
  },
  {
    value: "Blanc",
  },
  {
    value: "Rouge",
  },
  {
    value: "Violet",
  },
  {
    value: "Jaune",
  },
  {
    value: "Gris",
  },
  {
    value: "Beige",
  },
  {
    value: "Vert",
  },
  {
    value: "Or",
  },
  {
    value: "Argent",
  },
  {
    value: "Brun",
  },
  {
    value: "Bleu",
  },
  {
    value: "Orange",
  }
])
const currentYear = new Date().getFullYear()
// computed year variable
const yearStart = computed(() => {
  let list = [];
  for (let i = currentYear; i >= 1900; i--) {
    list.push(i);
  }
  return list;
});
const yearEnd = computed(() => {
  let list = [];
  for (let i = currentYear; i >= 1900; i--) {
    list.push(i);
  }

  return list;
});
//  price variable

const priceStart = ref(prix);
const priceEnd = ref(prix);


//  distance variable
const distanceStart = ref(distance);
const distanceEnd = ref(distance);
// city tooltip
const city = computed(() => {
  searchValues.cities = searchStore.getUserInput.cities;
  if (searchValues.cities) {
    if (searchValues.cities!.length >= 2) {
      return `${searchValues.cities?.at(0)}, +(${searchValues.cities!.length - 1
        })`;
    } else if (searchValues.cities!.length == 1) {
      return searchValues.cities!.at(0);
    }
  }
  return false;
});

// year selection update
const yearListUpdate = (value: any, isEndYear: boolean) => {
  searchStore.selectedInput.fromRegYear = searchValues.fromRegYear;
  searchStore.selectedInput.toRegYear = searchValues.toRegYear

  if (!value) {
    yearStart.value.splice(0);
    yearEnd.value.splice(0);

    for (let i = currentYear; i >= 1900; i--) {
      yearStart.value.push(i);
      yearEnd.value.push(i);
    }

  }
  else if (isEndYear) {
    yearStart.value.splice(0);
    for (let i = value; i >= 1900; i--) {
      yearStart.value.push(i);
    }

    if (searchStore.selectedInput.fromRegYear && searchStore.selectedInput.fromRegYear > value) {
      searchStore.selectedInput.fromRegYear = null;
    }
  }
  else {
    yearEnd.value.splice(0);
    for (let i = currentYear; i >= value; i--) {
      yearEnd.value.push(i);
    }

    if (searchStore.selectedInput.toRegYear && searchStore.selectedInput.toRegYear < value) {
      searchStore.selectedInput.toRegYear = null
    }
  }
  searchStore.searchCount()
};


// distance Max Update update
const distanceMaxUpdate = (
  value: any,
  isEndDistance: boolean
) => {
  searchStore.selectedInput.maxKilometers = searchValues.maxKilometers;
  searchStore.selectedInput.minKilometers = searchValues.minKilometers;

  if (!value) {
    distanceStart.value = [...distance];
    distanceEnd.value = [...distance];
  }
  else if (isEndDistance) {
    distanceStart.value = distance.slice(0, findIndexByValue(value ? value : distance.at(-1)?.value!, distance) + 1);
    if (searchStore.selectedInput.minKilometers && searchStore.selectedInput.minKilometers > value) {
      searchStore.selectedInput.minKilometers = null;
    }
  } else {
    distanceEnd.value = distance.slice(findIndexByValue(value ? value : distance.at(-1)?.value!, distance));
    if (searchStore.selectedInput.maxKilometers && searchStore.selectedInput.maxKilometers < value) {
      searchStore.selectedInput.maxKilometers = null
    }
  }
  searchStore.searchCount()
};

// Updates price Max and Min specification
const priceMaxUpdate = (value: number | null, isEndPrice: boolean) => {
  searchStore.selectedInput.maxPrice = searchValues.maxPrice;
  searchStore.selectedInput.minPrice = searchValues.minPrice;

  if (!value) {
    priceStart.value = [...prix];
    priceEnd.value = [...prix]
  }
  else if (isEndPrice) {
    priceStart.value = prix.slice(0, findIndexByValue(value ? value : prix.at(-1)?.value!, prix) + 1)
    if (searchStore.selectedInput.minPrice && searchStore.selectedInput.minPrice > value) {
      searchStore.selectedInput.minPrice = null;
    }
  } else {
    priceEnd.value = prix.slice(findIndexByValue(value ? value : prix.at(-1)?.value!, prix));
    if (searchStore.selectedInput.maxPrice && searchStore.selectedInput.maxPrice < value) {
      searchStore.selectedInput.maxPrice = null
    }
  }
  searchStore.searchCount();
};
const getUserMakesId = async () => {
  try {
    // console.log(searchStore.getUserMakesId);

    if (searchStore.getUserMakesId?.length !== 0) {
      await searchStore.fetchModels(searchStore.getUserMakesId);
    }
  } catch (error) {
    // console.log(error)
  }
};

// clear all filter
const clearFilter = async (obj: any) => {
  try {
    if (searchStore.getSelectedFilterCounte === 0) return;
    for (const key in obj) {
      if (Array.isArray(obj[key])) {
        obj[key] = [];
      } else {
        obj[key] = undefined;
      }
    }
    await searchStore.collectUserInput(searchValues);
    const hadQueryBeforeClear = Object.keys(router.currentRoute.value.query || {}).length > 0;
    await router.replace('/voitures');
    if (!hadQueryBeforeClear) {
      emit('apply-search');
    }
  } catch (error) {
    // console.log(error)
  }
};
// initiazlize
/*const initiazlizeInput = async (data: UserSearchInput) => {
  searchValues = data;
  
  searchValues.bodyColor = searchValues.bodyColor || [];

  // Helper function to safely parse a query string into an array
  const parseQueryArray = (queryString: string): string[] =>
    decodeURIComponent(queryString).split("_");

  // Process makes
  if (query.makes && typeof query.makes === "string") {
    const queryMakes = parseQueryArray(query.makes);

    const makesId: number[] = [];
    const foundMakes: typeof searchStore.getMakes = [];

    searchValues.makes = searchValues.makes || [];

    queryMakes.forEach((make) => {
      if (make.toLowerCase().includes("autres")) {
        searchValues.others = true;
      }

      const foundMake = searchStore.getMakes?.find(
        (storeMake) =>
          storeMake?.name?.toLowerCase() === make.toLowerCase()
      );

      if (foundMake) {
        foundMakes.push(foundMake);
        makesId.push(foundMake.id);
      }
    });

    if (makesId.length > 0) {
      await searchStore.fetchModels(makesId);
    }

    searchValues.makes.push(...foundMakes);

  }

  // Process models
  if (query.models && typeof query.models === "string") {
  const queryModels = parseQueryArray(query.models);

  const foundModels: fetchResult[] = [];

  searchValues.models = searchValues.models || [];

  queryModels.forEach((model) => {
    console.log(model); // e.g., 'A3'

    const matchedModel = searchStore.getModels && searchStore.getModels.find(
      (storeModel) => storeModel.name.toLowerCase() === model.toLowerCase()
    );

    console.log(matchedModel); // Should now log the matching object instead of undefined

    if (matchedModel) {
      foundModels.push(matchedModel);
    }
  });

  searchValues.models.push(...foundModels);
}

  // Process categories
  if (query.categories && typeof query.categories === "string") {
    searchValues.categories = parseQueryArray(query.categories);
  }

  // Process numeric values
  const numericFields = [
    "minPrice",
    "maxPrice",
    "minKilometers",
    "maxKilometers",
    "fromRegYear",
    "toRegYear",
  ] as const;

  numericFields.forEach((field) => {
    if (query[field]) {
      searchValues[field] = Number(query[field]);
    }
  });

  // Process string array fields
  const stringArrayFields = [
    "fuelTypes",
    "transmissions",
    "bodyColor",
  ] as const;

  stringArrayFields.forEach((field) => {
    if (query[field] && typeof query[field] === "string") {
      searchValues[field] = parseQueryArray(query[field]);
    }
  });

  // Process `placesNbr`
  if (query.placesNbr && typeof query.placesNbr === "string") {
    searchValues.placesNbr = parseQueryArray(query.placesNbr).map(Number);
  }

  if (query) {
    searchStore.fetchAnnounce(1, dashStore.getUserProfil.id);
  }

}

const searchFiltirs = ()=>{
  
  const updatedQuery = { ...query };
  console.log(searchStore.getUserInput);
  
  // Get all keys from searchStore.getUserInput

  for (const key in searchStore.getUserInput) {
    const value = searchStore.getUserInput[key];

    if (Array.isArray(value) && value.length > 0) {
      // For array values, join them with underscores after encoding and removing duplicates
      const queryString = Array.from(new Set(value.map(item => encodeURIComponent(item.name || item)))).join('_');
      updatedQuery[key] = queryString;
    } else if (value !== null && value !== undefined && !Array.isArray(value)) {
      // For scalar values, add them directly
      updatedQuery[key] = encodeURIComponent(value);
    }
  }

  // Push the new route with the merged query parameters
  router.push({ path: "/voitures", query: updatedQuery }).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      console.error(err);
    }
  });
}
*/

const applySearch = async () => {

  const searchQuery = searchQuerys(searchValues, searchStore);
  const targetPath = `/voitures?${searchQuery.toString()}`;

  // Trigger fetch flow immediately (important on first mobile apply).
  searchStore.userInput = { ...searchStore.selectedInput };
  emit('apply-search');
  emit("scrollToTop", true);

  // Keep URL in sync without blocking API trigger.
  await router.replace(targetPath);
};

const handleMobileApplySearch = async () => {
  try {
    await applySearch();
  } finally {
    emit('update:showFilterSideBar', false);
  }
};
async function clearSpecficFilter(key: string, index?: number) {
  // console.log(searchValues);
  Object.assign(searchStore.selectedInput, searchValues)
  const input = searchStore.selectedInput as Record<string, any>

  if (!(key in input)) return

  if (Array.isArray(input[key])) {
    input[key].splice(index!, 1)

    if (input[key].length === 0) {
      delete input[key]
    }
  } else {
    // Scalar values (minPrice, maxPrice, etc.)
    delete input[key]

    // Optional: Reset the original `searchValues` for UI sync
    if (key === 'minPrice') searchValues.minPrice = null
    if (key === 'maxPrice') searchValues.maxPrice = null
    if (key === 'minKilometers') searchValues.minKilometers = null
    if (key === 'maxKilometers') searchValues.maxKilometers = null
    if (key === 'fromRegYear') searchValues.fromRegYear = null
    if (key === 'toRegYear') searchValues.toRegYear = null
  }
  await searchStore.searchCount()
}

onBeforeMount(async () => {

  if (searchStore.getMakes && searchStore.getMakes.length === 0) {
    await searchStore.fetchMarks();
  }
  if (query && (width.value > breakpoints.screen_laptop)) {

    // initiazlizeInput(searchStore.getUserInput)

    if (Object.keys(query).length > 0) {
      const data = await initializeInputs(searchStore.getUserInput, searchStore, query);
      searchStore.selectedInput = Object.assign(searchValues, data);
      searchStore.userInput = { ...searchStore.selectedInput };
    }


    const forwardPath = String(router.options.history.state?.forward ?? '')
    const cameFromVoituresDetails = forwardPath.includes("/voitures/")
    const hasCachedResults = Boolean(searchStore.getFetchResult?.announcements?.length);
    const cachedFilters = searchStore.searchResult?.filters;
    const cachedMatchesQuery = cachedFilters
      ? JSON.stringify(searchStore.filterUserSearchInput(cachedFilters)) ===
      JSON.stringify(searchStore.filterUserSearchInput(searchStore.userInput))
      : false;

    if (!cameFromVoituresDetails && (!hasCachedResults || !cachedMatchesQuery)) {
      // Listing page owns data fetching order (promoted first, then search-result).
    }


  }

  if (query && width.value < breakpoints.screen_laptop) {
    Object.assign(searchValues, await searchStore.getUserInput);
  }

  if (Object.keys(searchStore.selectedInput).length > 0) {
    Object.assign(searchValues, searchStore.selectedInput);
  }

});

watch(
  () => searchStore.getUserInput,
  (next) => {
    syncSearchValues(next || {});
  },
  { deep: true }
);

</script>

<style lang="scss" scoped>
@import "~/assets/styles/_mixins.scss";

.side-nav {
  width: 100%;

  @include screen-laptop-above-xl {
    width: 264px;
  }
}

.side-nav-inner {
  padding: 16px;
}

.custom-city .p-tooltip-text {
  font-size: 12px;
  background-color: #101828;
}

.p-tooltip {
  display: inline-block !important;
}

.btn-result {
  position: sticky;
  box-shadow: 0 -1px 4px 0 var(--colors-elevation-1, rgba(109, 109, 131, 0.25))
}
</style>